import MarqueeLib from "react-fast-marquee";

const DEFAULT_ITEMS = [
  "Answered in under five minutes",
  "Every lead owned",
  "No voicemail left unchecked",
  "HIPAA-aware coordinators",
  "Numbers, not gut feelings",
  "The Back-Office Engine™",
];

export const Marquee = ({ reverse = false, items = DEFAULT_ITEMS, testid = "editorial-marquee" }) => (
  <div
    data-testid={testid}
    className="border-y border-black/5 bg-coal py-8 overflow-hidden"
    aria-hidden="true"
  >
    <MarqueeLib speed={25} gradient={false} pauseOnHover direction={reverse ? "right" : "left"}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic font-light text-2xl md:text-4xl text-zinc-500 px-12 whitespace-nowrap">
            {item}
          </span>
          <span className="text-champagne text-sm">✦</span>
        </span>
      ))}
    </MarqueeLib>
  </div>
);
